<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Add Property Photos'"
      [canGoBack]="true"
      [customBack]="fromGettingStarted ? 'get-started-status' : null" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (!loaded) {
      <div class="loading-container">
        <tidy-loader />
      </div>
    }
    @if (loaded) {
      <div class="wizard-progress-bar">
        <div class="wizard-progress-fill" [style.width.%]="progressPercent"></div>
      </div>

      @if (currentStep === 1) {
        <div class="wizard-step-header">
          <tidy-text [title]="'Do you have photos we can use for your listing?'" />
        </div>

        <div class="wizard-cards">
          @for (option of hasPhotosOptions; track option.viewValue) {
            <tidy-card
              class="wizard-card"
              (click)="selectHasPhotos(option.value)">
              <div class="wizard-card-radio" [ngClass]="hasPhotos === option.value ? 'wizard-card-radio-selected' : ''">
                <span class="wizard-card-radio-inner"></span>
              </div>
              <div class="wizard-card-text">
                <tidy-text [body]="option.viewValue" />
              </div>
            </tidy-card>
          }
        </div>
      }

      @if (currentStep === 2) {
        @if (hasPhotos === true) {
          <div class="wizard-step-header">
            <tidy-text [title]="'Add Your Photos'" />
          </div>

          <div class="wizard-content">
            <tidy-row>
              <tidy-button
                [text]="'Add Photos'"
                [action]="openPhotoPicker"
                class="secondary full-width" />
            </tidy-row>

            <tidy-row>
              <tidy-file-upload
                #photoPicker
                [id]="pickerInputId"
                [images]="photos"
                [multiple]="true"
                (addedImagesChange)="onPhotosAdded($event)"
                (removedImageChange)="onPhotoRemoved($event)"
                (fileError)="onFileError($event)" />
            </tidy-row>
          </div>
        }

        @if (hasPhotos === false) {
          <div class="wizard-step-header">
            <tidy-text [title]="'Do you want us to hire a photographer?'" />
          </div>

          <div class="wizard-cards">
            @for (option of photographerOptions; track option.viewValue) {
              <tidy-card
                class="wizard-card"
                (click)="selectPhotographer(option.value)">
                <div class="wizard-card-radio" [ngClass]="hirePhotographer === option.value ? 'wizard-card-radio-selected' : ''">
                  <span class="wizard-card-radio-inner"></span>
                </div>
                <div class="wizard-card-text">
                  <tidy-text [body]="option.viewValue" />
                </div>
              </tidy-card>
            }
          </div>
        }

        <div class="wizard-content">
          <div class="property-photos-nav-row">
            <tidy-button
              [text]="isSubmitting ? 'Submitting...' : 'Submit'"
              [action]="submit"
              [disabled]="isSubmitting || !canSubmit"
              class="primary" />
          </div>
        </div>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
